import { Injectable } from '@angular/core';

import { Error } from '../shared/models/error';
import { LogErrorGQL } from './log-error.query';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  private errorsToKeep = 10;
  private threshold = 5;
  private mostRecentErrors: Error[] = [];

  constructor(private logErrorMutation: LogErrorGQL) { }

  logError(error: Error): void {
    this.cacheError(error);

    if (this.existingError(error)) { return; }

    this.logErrorMutation.mutate({
      data: {
        message: error.message,
        stackTrace: error.stackTrace
      }
    })
      .subscribe(err => console.warn(`Error recorded`, err));
  }

  private cacheError(error: Error): void {
    if (this.mostRecentErrors.length === this.errorsToKeep) {
      this.mostRecentErrors.shift();
    }
    this.mostRecentErrors.push(error);
  }

  private existingError(error: Error): boolean {
    const sameErrors = this.mostRecentErrors
      .map(x => x.message)
      .filter(x => x === error.message).length;

    return sameErrors >= this.threshold;
  }
}
